import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd';
import { useKehulxListQuery } from '../../store/DianShangYeWuApi';

function ClientTypeSelect(props) {
    const [list,setList] = useState();
    const {data, isSuccess} = useKehulxListQuery({khlx_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {khlx_id,khlx_name }=item;
                    return item = {value:khlx_id,label:khlx_name,key:khlx_id}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    
    // 如果wrapperCol为null，说明是作为子组件使用，不包装Form.Item
    if (props.wrapperCol === null) {
        return (
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder || '请选择客户类型'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />
        )
    }

    return (
        <Form.Item 
            label={props.label} 
            required={props.required}  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
            name={props.name}
        >
            <Select
                options={list} 
                onChange={(_,f) => {
                    console.log(f);
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder || '请选择客户类型'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />                        
        </Form.Item>
    )
}

export default ClientTypeSelect
